'use strict'
import React from "react";

export const capitalize = (str=null) => {
  if(!str || str == undefined) {
    return ""
  }
  return `${str?.[0]?.toUpperCase()}${str?.slice(1)}`
}

export const camelCase = (str=null) => {
  if(!str || str == undefined) {
    return ""
  }
  return str?.toLowerCase()?.replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr?.toUpperCase())
}

export const pathname = (path="") => {
  return path && path[0] == "/" ? path.replace("/","") : path
}

export const parsePathUri = (path="") => {
  return path ? path?.split('?')?.[0] : path
}

export const formatDecimal = (value) => {
  //return (Math.trunc(value * 100)) / 100
  return Number(value.toString().match(/^\d+(?:\.\d{0,2})?/))
}

export const stringSanitizer = (string) => {

  let sanitizeString = string

  sanitizeString = sanitizeString.replace(/\d+|^\s+|\s+$/g,'')
  sanitizeString = sanitizeString.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g,'')

  return sanitizeString;

}

export const isNotEmpty = (value) => {
    return value.trim () !== '' ? true : false;
}

export const isEmailValid = (email, domainsToReject = []) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Check if the email's domain is in the list of domains to reject
    const emailParts = email.split('@');
    if (emailParts.length === 2) {
        const domain = emailParts[1].toLowerCase();
        if (domainsToReject.includes(domain)) {
        return false; // Reject emails with the specified domains
        }
    }
    
    return emailRegex.test(email);
}

export const combineNames = (firstName, lastName) => {
    const fullName = `${capitalize(firstName)} ${capitalize(lastName)}`;

    return fullName;
  };
  

export const parseEOJD = (string) => {
    const marker = "End of Job Description";
    const endIndex = string.indexOf(marker);

    if (endIndex !== -1) {
        const truncatedText = string.substring(0, endIndex);
        return truncatedText
   }else{
        return string
    }
}

export const FormatResponse = (jdResponse) => {
  if(typeof jdResponse !== 'string' || !jdResponse.trim()) {
    return null; // or handle the empty case as per your requirement
  }

  const lines = jdResponse.split("\n");
  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line.startsWith("Job Description:") ||
      line.startsWith("Role:") ||
      line.startsWith("Responsibilities:") ||
      line.startsWith("Results:") ||
      line.startsWith("Requirements:") ? (
        <strong style={{ color: "#00bfff" }}>{line}</strong>
      ) : (
        line
      )}
      <br />
    </React.Fragment>
  ));
};
